import { useState, useEffect, useContext } from 'react';
import Layout from "../../Components/Layout/Layout";
import { Row, Col, Input, message } from 'antd';
import styles from './Cart.module.scss';
import { MdClose } from 'react-icons/md';
import { Select } from 'antd';
import { useHistory } from 'react-router-dom';
import axios from '../../config/axios';
import { countries } from '../../utils';

//importing context api;
import { GlobalStates } from "../../Contexts/GlobalStates";

const Cart = () => {

    const history = useHistory();
    const [cart, setCart] = useState([]);
    const [states, setStates] = useState([]);
    const [curState, setCurState] = useState('');
    const [shipping, setShipping] = useState(0);
    const [country, setCountry] = useState(null);
    const [sTotal, setSTotal] = useState(0);
    const [refresh, setRefresh] = useState(null);
    const [address1, setAddress1] = useState('');
    const [city, setCity] = useState('');
    const [phone, setPhone] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [currency, setCurrency] = useState('');
    const [days, setDays] = useState('');

    const { gRefresh, setGRefresh } = useContext(GlobalStates);

    useEffect(() => {
        if (localStorage.getItem('cartData')) {
            setCart(JSON.parse(localStorage.getItem('cartData')));
        }
    }, []);

    useEffect(() => {
        let total = 0;
        cart.forEach(item => {
            total = total + (item.price * item.quantity);
        });
        setSTotal(total);
    }, [cart, refresh, gRefresh]);

    //defining removeItemFromCart function
    const removeItemFromCart = (index) => {
        let newArr = [];
        for (let i = 0; i < cart.length; i++) {
            if (i !== index) {
                newArr.push(cart[i]);
            }
        }
        // console.log(index);
        setCart(newArr);
        localStorage.setItem('cartData', JSON.stringify(newArr));
        setGRefresh(Math.random());
    }


    //defining getCartTotal function
    function getCartTotal() {
        let total = 0;
        cart.forEach(item => {
            total = total + (item.price * item.quantity);
        });

        return total;
    }

    //defining calcShipping function
    const calcShipping = () => {
    	if( !address1 || !city || !country){
		message.success('Values is required');
	}else{
		var temp = []
		cart.forEach(item => {
		     temp = temp.concat({
			"variant_id": item.variant_id,
			"quantity": item.quantity,})
		});
		var data = {
			"recipient": {
			    "address1": address1,
			    "city": city,
			    "country_code": country,
			    "state_code": curState,
			    "zip":zipCode,
			},
			"items": temp,
		}
		console.log(data)
		axios.post(`printful/get-shpping`, {data : data}  ).then(response => {
			console.log(response.data.result)
            message.success('Shipping charge added');
            // console.log(response.data);
			setShipping(response.data.result[0].rate);
			setCurrency(response.data.result[0].currency);
			setDays(response.data.result[0].minDeliveryDays + " ~ " + response.data.result[0].maxDeliveryDays);
		});
	}
    }

    //defining changeQuantity
    const changeQuantity = (value, item) => {
        const index = cart.indexOf(item);
        let bCart = cart;
        bCart[index].quantity = value;
        setCart(bCart);
        localStorage.setItem('cartData', JSON.stringify(bCart));
        setRefresh(Math.random());
    }

    return (
        <Layout
            title={'Shopping Cart'}
        >
            <div className={'container ' + styles.wrapper} style={{ marginTop: '4rem', marginBottom: '4rem' }}>
                <Row gutter={[26, 26]}>
                    <Col xs={24} sm={16}>
                        <div className={styles.table_wrapper}>
                            <table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th>ITEM</th>
                                        <th>PRICE</th>
                                        <th>{ window.innerWidth >= 576? "QUANTITY" : "QUAN"}</th>
                                        <th>TOTAL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        cart.map((item, index) => {
                                            return <tr key={index}>
                                                <td style={{  alignItems: 'center', display: window.innerWidth >= 576?  'flex':'grid'}}>
                                                    <img width={'100px'} src={item.design} alt="" style={{ marginRight: '1rem' }} />
                                                    <span>{item.name}</span>
                                                </td>
                                                <td>
                                                    <span >USD ${item.price}</span>
                                                </td>
                                                <td>

                                                    {/* <InputNumber
                                                            min={1}
                                                            defaultValue={item.quantity}
                                                            onChange={value => changeQuantity(value, item)}
                                                        /> */}
                                                    <div className={styles.qty}>
                                                        <button
                                                            style={{ borderRight: window.innerWidth >= 576? '1px solid #d9d9d9':'none', borderBottom: window.innerWidth >= 576? 'none' :'1px solid #d9d9d9' }}
                                                            onClick={() => {
                                                                if (item.quantity - 1 !== 0) {
                                                                    changeQuantity(item.quantity - 1, item)
                                                                }
                                                            }}
                                                        >
                                                            -
                                                        </button>
                                                        <button>{item.quantity}</button>
                                                        <button onClick={() => changeQuantity(item.quantity + 1, item)} style={{ borderLeft: window.innerWidth >= 576? '1px solid #d9d9d9' :'none', borderTop: window.innerWidth >= 576? 'none' :'1px solid #d9d9d9'}}>+</button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style={{ flexDirection: 'column', alignItems: 'center'  }}>
                                                        <MdClose onClick={() => removeItemFromCart(index)} size={20} style={{ cursor: 'pointer' }} />
                                                        <span >
                                                            USD ${item.price * item.quantity}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className={styles.box} style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem', border: '1px solid #e6e6e6', borderRadius: '10px', padding: '1rem 2rem' }}>
                            <a href="/earn"><button className='primary-button' style={{width:'170px'}}>Design More</button></a>
                            <a href="/#pr"><button className='primary-button' style={{width:'170px'}}>Shop More</button></a>
                        </div>
                    </Col>
                    <Col xs={24} sm={8}>
                        <div className={styles.calc}>
                            <span style={{ fontSize: '1.45rem', fontWeight: 'bold' }}>CART TOTAL</span>
                            <div className={styles.info} style={{ marginTop: '1rem' }}>
                                <span>Subtotal: </span>
                                <span style={{ marginLeft: '1rem' }}>USD ${sTotal.toFixed(2)} </span>
                            </div>
                            <hr className={styles.hr} />
                            <div className={styles.info} style={{ marginTop: '0rem', display: 'flex' }}>
                                <span>Shipping: </span>
                                <div style={{ marginLeft: '1rem', display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontSize: '.8rem' }}>Calculate Shipping</span>
				    <Input style={{ marginTop: '.5rem' }} name='address1' type={'text'} placeholder='Address1' value={address1} onChange={(e) => {setAddress1(e.target.value)}} />
				    <Input style={{ marginTop: '.5rem' }} name='city' type={'text'} placeholder='City' value={city} onChange={(e) => {setCity(e.target.value)}}/>
                                    <Select
                                        style={{ marginTop: '.5rem' }}
                                        placeholder='Select country'
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        showSearch
                                        onChange={(value) => {
                                            setCountry(value);
                                            for (let i = 0; i < countries.length; i++) {
                                                if (countries[i].code === value) {
                                                    setStates(countries[i].states ? countries[i].states : []);
                                                }
                                            }
                                        }}
                                    >
                                        {
                                            countries.map((country, index) => {
                                                return <Select.Option value={country.code} >{country.name}</Select.Option>
                                            })
                                        }
                                    </Select>

                                    <Select
                                        style={{ marginTop: '.5rem' }}
                                        placeholder='Select state'
					onChange={(value) => {
                                            setCurState(value);
                                        }}
                                    >
                                        {
                                            states.map((state, index) => {
                                                return <Select.Option>{state.name}</Select.Option>
                                            })
                                        }
                                    </Select>

                                    <Input style={{ marginTop: '.5rem' }} name='zipcode' type={'text'} placeholder='Postal Code / Zip' value={zipCode} onChange={(e) => {setZipCode(e.target.value)}}/>
				    <Input style={{ marginTop: '.5rem' }} name='phone' type={'text'} placeholder='Phone' value={phone} onChange={(e) => {setPhone(e.target.value)}}/>
                                    <button onClick={() => {
                                        if (!country) {
                                            message.error('Country is required!');
                                        } else {
                                            calcShipping();
                                        }
                                    }} style={{ marginTop: '1rem' }} className='primary-button'>Update Total</button>
                                </div>

                            </div>
                            <hr className={styles.hr} />
			    {
			    	    shipping ? 
				    <div className={styles.info} style={{ marginTop: '0rem' }}>
					<span>DeliveryDays: </span>
					<span style={{ marginLeft: '1rem', marginRight: '1rem' }}>{days} days </span><br></br>
					<span>Currency: </span>
					<span style={{ marginLeft: '1rem', marginRight: '1rem' }}>"{currency}" </span>
					<span>rate: </span>
					<span style={{ marginLeft: '1rem', marginRight: '1rem' }}>${shipping} </span><br></br>
					<span>Total: </span>
					<span style={{ marginLeft: '1rem' }}>USD ${(parseFloat(sTotal) + parseFloat(shipping)).toFixed(2)} </span>
				    </div>
				    :
				    <div className={styles.info} style={{ marginTop: '0rem' }}>
					<span>Total: </span>
					<span style={{ marginLeft: '1rem' }}>USD ${parseFloat(sTotal).toFixed(2)} </span>
				    </div>
			    }
                            <hr className={styles.hr} />
                            <button onClick={() => {
                                if (!shipping) {
                                    message.error('Please provide delivery details and update total first!')
                                } else {
                                    history.push(`/checkout/${shipping}`);
                                }
                            }} style={{ width: 'fit-content', alignSelf: 'center' }} className='primary-button'>Checkout</button>
                        </div>
                    </Col>
                </Row>
            </div>
        </Layout>
    );
};

export default Cart;